export default [
    {
        path: "/app",
        name: "app",
        meta: {
            authRequired: true,
        },
        component: () => import("../views/layouts/phone.vue"),
        redirect: {name: 'app-home'},
        children: [
            {
                path: '',
                name: 'app-home',
                component: () => import('../views/pages/app/home.vue'),
            },
            {
                path: 'onboarding',
                name: 'app-onboarding',
                component: () => import('../views/pages/app/onboarding.vue'),
            },
            {
                path: 'health',
                name: 'app-health',
                component: () => import('../views/pages/app/health/index.vue'),
            },
            {
                path: 'health/:diary',
                name: 'app-health-detail',
                component: () => import('../views/pages/app/health/detail.vue'),
            },
            {
                path: 'journey',
                name: 'app-journey',
                component: () => import('../views/pages/app/journey/index.vue'),
            },
            {
                path: 'journey/vitality',
                name: 'app-journey-vitality',
                component: () => import('../views/pages/app/journey/vitality.vue'),
            },
            {
                path: 'journey/tasks',
                name: 'app-journey-tasks',
                component: () => import('../views/pages/app/journey/tasks.vue'),
            },
            {
                path: 'journey/plans',
                name: 'app-journey-plans',
                component: () => import('../views/pages/app/journey/plans.vue'),
            },
            {
                path: 'journey/plans/new',
                name: 'app-journey-plan-new',
                component: () => import('../views/pages/app/journey/plan-new.vue'),
            },
            {
                path: 'programs',
                name: 'app-programs',
                component: () => import('../views/pages/app/programs/index.vue'),
            },
            {
                path: 'programs/:id',
                name: 'app-program-show',
                component: () => import('../views/pages/app/programs/show.vue'),
            },
            {
                path: 'programs/:id/activate',
                name: 'app-program-activate',
                component: () => import('../views/pages/app/programs/activate.vue'),
            },
            {
                path: 'profile',
                name: 'app-profile',
                component: () => import('../views/pages/app/profile.vue'),
            },
        ],
    },
    {
        path: "/",
        name: "home",
        redirect: {name: "app"},
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/pages/account/login"),
    },
    {
        path: "/error/404-basic",
        name: "error-404-basic",
        component: () => import("../views/pages/errors/404-basic"),
    },
    {
        path: "/error/404-cover",
        name: "error-404-cover",
        component: () => import("../views/pages/errors/404-cover"),
    },
    {
        path: "/error/500-basic",
        name: "error-500-basic",
        component: () => import("../views/pages/errors/500-basic"),
    },
    {
        path: "/error/500-cover",
        name: "error-500-cover",
        component: () => import("../views/pages/errors/500-cover"),
    },
    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        redirect: {name: "error-404-basic"},
    },
];
